import * as types from "../types";

const initialState = {
    loading: false,
    reqAuctionId: null,
    user_id: null,
    resauctionInvData: null,
    error: null
} 

export default function auctionInvReducer(state = initialState, action){

    switch(action.type){
        case types.FETCH_AUCTION_INV_REQUEST:
            return {
                ...state,
                loading: true,
                user_id: action.payload.user_id,
                reqAuctionId: action.payload.reqAuctionId,
                error: null
            }

        case types.FETCH_AUCTION_INV_SUCCESS: 
            return {
                ...state,
                loading: false,
                resauctionInvData: action.payload.resauctionInvData
            }

        case types.FETCH_AUCTION_INV_FAILURE: 
            return {
                ...state,
                loading: false,
                resauctionInvData: null,
                error: action.payload.error
        }    

        case types.FETCH_AUCTION_INV_RESET: 
        return {
            ...state,
            loading: false,
            user_id: null,
            reqAuctionId: null,
            resauctionInvData: null,
            error: null
        }  


        default : 
            return state
    }

}